export const GET_DEVICES_GROUP = "GET_DEVICES_GROUP";